import React from "react";
import Placeholder from "../../../assets/images/Placeholder.png";
import { Button, Col, Row } from "reactstrap";
import { FaMapMarker } from "react-icons/fa";
import { toast } from "react-toastify";
import { updateMessageSettingStatus } from "../../../components/Header/Data3";

const ScheduleMessageList = ({
  scheduledMessages,
  setAutoScheduledMessage,
  fetchlistMessageSetting,
}) => {
  console.log(scheduledMessages, "scheduledMessages");
  const getOrdinalSuffix = (n) => {
    if (n === 1) return "st";
    if (n === 2) return "nd";
    if (n === 3) return "rd";
    return "th";
  };
  const handleActive = async (message) => {
    const formData = {
      Id: message?.Id, // lowercase unless your API needs 'Id'
      messageSettingStatus: 1,
    };

    try {
      await updateMessageSettingStatus(formData);
      toast.success("Message Activated");
      fetchlistMessageSetting();
    } catch (error) {
      console.error("Failed to update message status", error);
      // Optionally show user feedback here
    }
  };
  const handlePause = async (message) => {
    const formData = {
      Id: message?.Id, // lowercase unless your API needs 'Id'
      messageSettingStatus: 3,
    };

    try {
      await updateMessageSettingStatus(formData);
      toast.info("Message Paused");
      fetchlistMessageSetting();
    } catch (error) {
      console.error("Failed to update message status", error);
      // Optionally show user feedback here
    }
  };
  return (
    <Row
      className="d-flex align-items-center justify-content-center"
      style={{
        margin: "0 7px",
        padding: "20px",
        boxShadow: "1px 1px 6px #888888",
        borderRadius: "15px",
      }}
    >
      {scheduledMessages.map((message) => (
        <Row
          key={message.id}
          className="need-card"
          style={{ marginBottom: "15px" }}
        >
          <Col className="img needs-image p-0">
            <img
              className="w-100"
              style={{ height: "185px" }}
              src={message.messageImage ? message.messageImage : Placeholder}
              alt={message.messageContent}
            />
          </Col>
          <Col className="need-info">
            <Row
              style={{ alignItems: "start", fontSize: "15px" }}
              className="pe-3 pt-3"
            >
              <Col sm="6" xs="12" lg={8}>
                <div>
                  <b>Name:</b> {`${message?.firstName} ${message?.lastName}`}
                </div>
                <div>
                  <b>Email:</b> {message.Email}
                </div>
                <div>
                  <b>Phone:</b> {`${message?.countryCode} ${message?.Phone}`}
                </div>
                <div>
                  <b>Message Type:</b>
                  {`${message.messageType}${getOrdinalSuffix(
                    message.messageType
                  )} message`}
                </div>
                <div>
                  <b>Hour Delay:</b> {message.hourDelay}
                </div>
                <div>
                  <b>Message Content:</b> {message.messageContent}
                </div>
              </Col>
              <Col sm="6" xs="12" lg={4} className=" mt-3 text-end">
                {message?.messageSettingStatus === 1 ? (
                  <Button
                    color="warning"
                    className="px-2 mx-1"
                    onClick={() => handlePause(message)}
                  >
                    Pause
                  </Button>
                ) : (
                  <Button
                    color="success"
                    className="px-2  mx-1"
                    onClick={() => handleActive(message)}
                  >
                    Active
                  </Button>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      ))}
    </Row>
  );
};

export default ScheduleMessageList;
